import { useEffect, useState, memo } from 'react';
import { getAgencyList } from './api';
import _ from 'lodash';

interface AgencyNameProps {
  agencyId: number;
}

const agencyList: any = {};

const AgencyName = (props: AgencyNameProps) => {
  const { agencyId } = props;
  const [agencyName, setAgencyName] = useState<string>('-');

  useEffect(() => {
    if (!agencyId) return;
    if (!agencyList[agencyId]) {
      getAgencyList({
        agencyId,
      })
        .then((res) => {
          const agency = res[0];
          agencyList[agencyId] = agency;
          if (agency.agencyName) {
            setAgencyName(`${agency.agencyName}(${agencyId})`);
          } else {
            setAgencyName(`${agencyId}`);
          }
        });
      return;
    }
    const agency = agencyList[agencyId];
    if (agency.agencyName) {
      setAgencyName(`${agency.agencyName}(${agencyId})`);
    } else {
      setAgencyName(`${agencyId}`);
    }
  }, [agencyId]);

  return (
    <span>
      {agencyName}
    </span>
  );
};

export default memo(AgencyName);
